<script>
    import { onDestroy } from "svelte";
    import { fade } from "svelte/transition";
    import { portal } from "svelte-portal";
    import { notification } from "./store";
    const themes = {
        default: "rgba(0, 0, 0, 0.9)",
        success: "rgba(82,196,26,.9)",
        warning: "rgba(250,173,20,.9)",
        danger: "rgba(245,24,45,.9)",
        info: "rgba(24,144,255,.9)",
    };
    //vars
    let items = [];
    let count = 1;
    const cls = "sui-toast";
    //delete items
    function removeToast(id) {
        items = items.filter((t) => t.id != id);
    }
    // create items
    function createToast(value) {
        //timeout 默认3s
        const { type, msg, timeout = 3000 } = value;
        items = [
            {
                msg,
                id: count,
                theme: themes[type],
                timeout,
            },
            ...items,
        ];
        count++;
    }
    //subscribe
    const unsubscribe = notification.subscribe((value) => {
        if (!value) return;
        createToast(value);
        notification.set();
    });
    //destory
    onDestroy(() => {
        unsubscribe();
    });
</script>

{#if items.length > 0}
    <ul class={cls} use:portal={"body"}>
        {#each items as item (item.id)}
            <li transition:fade>
                <span style="background-color: {item.theme}"
                    >{item.msg}<i
                        style="animation-duration:{item.timeout}ms"
                        on:animationend={() => removeToast(item.id)}
                    /></span
                >
            </li>
        {/each}
    </ul>
{/if}

<style lang="less">
    @import "./toast.less";
</style>
